﻿(function (w, a, y, f) {
    w._wayfinder = w._wayfinder || function () { (w._wayfinder.q = w._wayfinder.q || []).push(arguments) };
    p = { oaDomain: 'kluwerlaw.com', oaAppId: '53b4bbac-7c6e-4fd8-b721-0af797082c1a' };
    w._wayfinder.settings = p; h = a.getElementsByTagName('head')[0]; s = a.createElement('script'); s.async = 1;
    q = Object.keys(p).map(function (key) { return key + '=' + p[key] }).join('&');
    s.src = y + 'v1' + f + "?" + q; h.appendChild(s);
}
)(window, document, 'https://wayfinder.openathens.net/embed/', '/loader.js');


//////////////////
// WEBPACK FOOTER
// ./public/Wayfinder.js
// module id = 724
// module chunks = 1